import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { EventBusService } from "./core/services/event-bus.service";
import { DashboardModule } from "./dashboard/dashboard.module";
import { CommonLayoutComponent } from "./shared/layout/common-layout.component";
import { NbcSharedModule } from "./shared/shared.module";
import { SharedDataService } from "./shared/sharedData.service";
import { TimesheetModule } from "./timesheet/timesheet.module";
import { identityFactory } from "./core/services/identity.service";
import { ContactModule } from "./contact/contact.module";
import { HelpModule } from "./Misc/help/help.module";
import { UiSettingsFactory } from "./core/services/uisettings.service";
//import { LiquidCacheStorageTypes, NgxLiquidCacheModule } from 'ngx-liquid-cache';
import { PendingChangesGuard } from "./core/services/pendingchanges-guard.service";
import { NbcUnauthorized } from "./shared/component/unauthorized/nbc-unauthorized.component";
import { TimeZoneHelperService } from "./shared/helper/timezonehelper.service";
import { CustomHttpInterceptorService } from "./shared/helper/customHttpInterceptor.service";


@NgModule({
    declarations: [AppComponent, CommonLayoutComponent, NbcUnauthorized],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        DashboardModule,
        TimesheetModule,
        ContactModule,
        NbcSharedModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            {
                path: "Help",
                loadChildren: () => {
                    return HelpModule;
                },
            },
            { path: "unauthorized", component: NbcUnauthorized },
            { path: "**", component: NbcUnauthorized },
        ]),
        //NgxLiquidCacheModule.forRoot({
        //  duration: 600,
        //  localStoragePrefix: "nbc-tal-",
        //  shareBetweenTabs: true,
        //  storageType: LiquidCacheStorageTypes.localStorage
        //}),
    ],
    providers: [
        TimeZoneHelperService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptorService,
            multi: true,
        },
        provideAppInitializer(() => {
        const initializerFn = (identityFactory)(inject(HttpClient));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (UiSettingsFactory)(inject(HttpClient));
        return initializerFn();
      }),
        SharedDataService,
        PendingChangesGuard,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
